import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  prereqs: [
    'Tener creadas las obras: cada sector pertenece a una obra determinada.',
  ],
  tips: [
    'El sector divide una obra grande en frentes de trabajo: "Progresiva 12-18", "Planta de áridos", "Acceso norte".',
    'Sirve para saber en qué parte de la obra estuvo afectado cada equipo.',
    'Si una obra es chica y no necesita subdivisión, no hace falta crearle sectores.',
  ],
  nextSteps: [
    'El sector de trabajo permite indicar en los partes diarios donde trabajó el equipo. No debe confundirse con la ubicación de la obra.',
    'Los informes de uso permiten abrir los resultados por obra y sector.',
  ],
};

const ConfiguracionSectoresTrabajo = () => {
  return (
    <ConfiguracionBase
      apiEndpoint="sectores-trabajo"
      titulo="Sectores de Trabajo"
      descripcion="Gestión de sectores vinculados a cada obra"
      icon="fas fa-map-signs"
      compact
      help={HELP}
    />
  );
};

export default ConfiguracionSectoresTrabajo;
